import React from "react";
import { Button } from "react-bootstrap";
import { Phone, Mail, Printer, Edit2 } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";

import { getPracticePocTypeLabel } from "../../utils/practicePocTypes";
import { CopyChip, CopyText, NotesButton, SectionNav, SpecialtyPill, StickyHeader, UpdatedInfo } from "../header/HeaderParts";

const getInitials = (name) => {
  if (!name) {
    return "?";
  }
  const words = name.trim().split(/\s+/);
  return ((words[0] ? words[0].charAt(0) : "") + (words.length > 1 ? words[words.length - 1].charAt(0) : "")).toUpperCase();
};

const PracticeHeader = ({ data, canEdit, isH3Admin, onEditClicked, sections, onboardingStatus }) => {
  var endDateDisplay = null;
  if (data.endDate != null) {
    const parts = data.endDate.split("-");
    endDateDisplay = new Date(parts[0], parts[1] - 1, parts[2]).toLocaleDateString("en-US");
  }

  const pocs = data.practicePocs || [];

  return (
    <StickyHeader
      avatar={<div className="ph-avatar ph-avatar-square"><FontAwesomeIcon icon={faBuilding} /></div>}
      title={data.name}
      subtitle={data.specialties && data.specialties.length > 0 ? data.specialties[0].name : ""}
      extra={<SectionNav sections={sections} compact />}
    >
    <div className="provider-header">
      <div className="ph-avatar-wrap">
        <div className="ph-avatar ph-avatar-square" style={{ width: 56, height: 56, fontSize: 22 }}>
          <FontAwesomeIcon icon={faBuilding} />
        </div>
      </div>

      <div className="ph-main">
        <div className="ph-line">
          <h1 className="h3 ph-name"><CopyText text={data.name} label="practice name" />{onboardingStatus}</h1>
          {data.specialties && data.specialties.map((specialty) => <SpecialtyPill key={specialty.id} specialty={specialty} />)}
        </div>

        <div className="ph-line ph-contacts">
          {data.phone1 && <CopyChip label="Phone" value={data.phone1} icon={<Phone size={14} />} />}
          {data.fax && <CopyChip label="Fax" value={data.fax} icon={<Printer size={14} />} />}
          {data.email1 && <CopyChip label="Email" value={data.email1} icon={<Mail size={14} />} />}
          {data.tin && <CopyChip label="TIN" value={data.tin} icon={<span className="ph-cc">TIN</span>} />}
          {endDateDisplay && <span className="ph-end-date">End Date: {endDateDisplay}</span>}
        </div>

        {pocs.length > 0 &&
          <div className="ph-line">
            {pocs.map((poc) => {
              const name = [poc.firstName, poc.lastName].filter(Boolean).join(" ");
              const typeLabel = getPracticePocTypeLabel(poc.practicePocType);
              return (
                <span className="ph-chip ph-office-manager" key={poc.id}>
                  {name && <span className="ph-mini-avatar">{getInitials(name)}</span>}
                  {name && <span>{name}</span>}
                  <span className="ph-chip-dates">· {typeLabel}</span>
                  {poc.phone && <CopyChip label={typeLabel + " phone"} value={poc.phone} />}
                  {poc.email && <CopyChip label={typeLabel + " email"} value={poc.email} />}
                </span>
              );
            })}
          </div>
        }
      </div>

      <div className="ph-side">
        <div className="ph-actions">
          <SectionNav sections={sections} />
          <NotesButton notes={data.notes} />
          {canEdit &&
            <Button size="sm" variant="primary" onClick={onEditClicked}>
              <Edit2 size={14} /> Edit
            </Button>
          }
        </div>
        <UpdatedInfo
          updated={data.updated}
          updatedBy={data.updatedBy}
          extra={isH3Admin && data.defaultTaskAssignee != null ? <div>Auto. task assignee override (H3): {data.defaultTaskAssignee}</div> : null}
        />
      </div>
    </div>
    </StickyHeader>
  );
};

export default PracticeHeader;
